import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../utils/formatters';
import { useTranslatedName } from '../PostCards/useTranslatedName';
import './MapView.css';

/**
 * Map view for search results: shows products that have location.latitude/longitude
 * with a link to open in Google Maps. Does not embed a map (no API key required).
 */
function MapView({ products = [] }) {
  const { t } = useTranslation();
  const withLocation = products.filter(
    (p) =>
      p.location && p.location.latitude != null && p.location.longitude != null
  );

  if (withLocation.length === 0) {
    return (
      <div className="mapViewEmpty">
        <p>{t('search.mapViewEmpty')}</p>
      </div>
    );
  }

  const mapUrl = (lat, lng, label) => {
    const q = label
      ? `${lat},${lng} (${encodeURIComponent(label)})`
      : `${lat},${lng}`;
    return `https://www.google.com/maps?q=${q}`;
  };

  return (
    <div className="mapView">
      <ul className="mapViewList">
        {withLocation.map((p) => (
          <MapViewItem key={p.id} product={p} mapUrl={mapUrl} t={t} />
        ))}
      </ul>
    </div>
  );
}

function MapViewItem({ product, mapUrl, t }) {
  const name = useTranslatedName(product);
  return (
    <li className="mapViewItem">
      <Link to={`/ad/${product.id}`} className="mapViewItemTitle">
        {name}
      </Link>
      <span className="mapViewItemPrice">{formatPrice(product.price, product)}</span>
      {(product.location.area || product.location.city) && (
        <span className="mapViewItemLocation">
          {[product.location.area, product.location.city].filter(Boolean).join(', ')}
        </span>
      )}
      <a
        href={mapUrl(product.location.latitude, product.location.longitude, name)}
        target="_blank"
        rel="noopener noreferrer"
        className="mapViewItemMapLink"
      >
        {t('search.viewOnMap')}
      </a>
    </li>
  );
}

export default MapView;
